export const dayOfWeekShortForm = {
  MON: 'MON',
  TUE: 'TUE',
  WED: 'WED',
  THU: 'THU',
  FRI: 'FRI',
  SAT: 'SAT',
  SUN: 'SUN',
};

export const dayOfWeekFullForm = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
};

export const daysOfWeekFormsByFullForm = {
  shortForm: {
    [dayOfWeekFullForm.Monday]: dayOfWeekShortForm.MON,
    [dayOfWeekFullForm.Tuesday]: dayOfWeekShortForm.TUE,
    [dayOfWeekFullForm.Wednesday]: dayOfWeekShortForm.WED,
    [dayOfWeekFullForm.Thursday]: dayOfWeekShortForm.THU,
    [dayOfWeekFullForm.Friday]: dayOfWeekShortForm.FRI,
    [dayOfWeekFullForm.Saturday]: dayOfWeekShortForm.SAT,
    [dayOfWeekFullForm.Sunday]: dayOfWeekShortForm.SUN,
  },
};

export const daysOrderByForm = {
  shortForm: {
    [dayOfWeekShortForm.MON]: 0,
    [dayOfWeekShortForm.TUE]: 1,
    [dayOfWeekShortForm.WED]: 2,
    [dayOfWeekShortForm.THU]: 3,
    [dayOfWeekShortForm.FRI]: 4,
    [dayOfWeekShortForm.SAT]: 5,
    [dayOfWeekShortForm.SUN]: 6,
  },
  fullForm: {
    [dayOfWeekFullForm.Monday]: 0,
    [dayOfWeekFullForm.Tuesday]: 1,
    [dayOfWeekFullForm.Wednesday]: 2,
    [dayOfWeekFullForm.Thursday]: 3,
    [dayOfWeekFullForm.Friday]: 4,
    [dayOfWeekFullForm.Saturday]: 5,
    [dayOfWeekFullForm.Sunday]: 6,
  },
};

export const daysByOrder = {
  0: dayOfWeekFullForm.Monday,
  1: dayOfWeekFullForm.Tuesday,
  2: dayOfWeekFullForm.Wednesday,
  3: dayOfWeekFullForm.Thursday,
  4: dayOfWeekFullForm.Friday,
  5: dayOfWeekFullForm.Saturday,
  6: dayOfWeekFullForm.Sunday,
};
